import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaSearch, FaBars, FaTimes } from "react-icons/fa";
import jobs from "../../data/jobs";
import { searchIndex } from "../../utils/searchIndex";
import ScrollingNotice from "../ScrollingNotice";

export default function Navbar1() {
  const [navItems] = useState([
    {
      label: "What We Do",
      dropdown: [
        { name: "Services", path: "/services" },
        { name: "Network", path: "/network" },
      ],
    },
    {
      label: "What We Serve",
      dropdown: [
        { name: "Our Expertise", path: "/our-expertise" },
        { name: "Who We Serve", path: "/who-we-serve" },
      ],
    },
    {
      label: "Careers",
      dropdown: [
        { name: "Explore Open Positions", path: "/careers" },
        { name: "Current Opportunities", path: "/joblist" },
      ],
    },
    {
      label: "Who We Are",
      dropdown: [{ name: "About Us", path: "/about" }],
    },
  ]);

  const [showSearch, setShowSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [mobileMenu, setMobileMenu] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 769);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 769);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenu(!mobileMenu);
    if (!mobileMenu) setOpenDropdown(null);
  };

  const toggleDropdown = (index) => {
    if (isMobileView) {
      setOpenDropdown(openDropdown === index ? null : index);
    }
  };

  const handleLinkClick = () => {
    setMobileMenu(false);
    setOpenDropdown(null);
  };

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      const query = searchTerm.trim().toLowerCase();
      if (!query) return;

      const allLinks = navItems.flatMap((item) =>
        item.dropdown
          ? item.dropdown.map((sub) => ({
              name: sub.name.toLowerCase(),
              path: sub.path,
            }))
          : [{ name: item.label.toLowerCase(), path: item.path }]
      );

      const navMatch = allLinks.find((link) => link.name.includes(query));
      if (navMatch) {
        navigate(navMatch.path);
      } else {
        const jobMatch = jobs.find((job) =>
          job.title.toLowerCase().includes(query)
        );
        if (jobMatch) {
          navigate(`/careers/job-details/${jobMatch.id}`);
        } else {

          const contentMatches = searchIndex(query);

          if (contentMatches.length > 0) {

            navigate(`${contentMatches[0].path}?highlight=${encodeURIComponent(query)}`);
          } else {
            navigate(`/search?query=${encodeURIComponent(query)}`);
          }
        }
      }
      setShowSearch(false);
      setSearchTerm("");
      setMobileMenu(false);
    }
  };

  return (
    <>
      <div className="sticky top-0 z-[9999] bg-white shadow-sm">
        <div className="flex items-center justify-between px-6 py-4">

          <Link to="/" className="flex items-center">
            <img src="/adithya logo.jpg" alt="Brand Logo" className="h-14 w-auto" />
          </Link>


          <div className="lg:hidden cursor-pointer" onClick={toggleMobileMenu}>
            {mobileMenu ? <FaTimes size={40} /> : <FaBars size={40} />}
          </div>


          <ul className="hidden lg:flex items-center gap-10 text-base font-medium navbar-links">
            {navItems.map((item, index) => (
              <li key={index} className="nav-item relative group">
                <button
                  onClick={() => toggleDropdown(index)}
                  className="hover:text-blue-600"
                >
                  {item.label} ▾
                </button>

                {item.dropdown && (
                  <div
                    className={`dropdown-menu absolute left-0 top-full bg-white border shadow-md rounded-md w-52 flex-col z-50 ${
                      openDropdown === index ? "flex" : "hidden group-hover:flex"
                    }`}
                  >
                    {item.dropdown.map((sub, subIndex) => (
                      <Link
                        key={subIndex}
                        to={sub.path}
                        onClick={handleLinkClick}
                        className="px-4 py-2 text-sm hover:bg-gray-100"
                      >
                        {sub.name}
                      </Link>
                    ))}
                  </div>
                )}
              </li>
            ))}

            <li className="nav-item">
              <Link
                to="/contact"
                onClick={handleLinkClick}
                className="bg-black text-white px-5 py-2 rounded-md hover:bg-gray-800 transition"
              >
                Contact Us
              </Link>
            </li>


            <li className="flex items-center relative">
              {showSearch ? (
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={handleSearch}
                  placeholder="Search..."
                  className="ml-2 px-3 py-1 border border-gray-300 rounded-full text-sm focus:outline-none w-40 transition-all"
                  autoFocus
                />
              ) : (
                <FaSearch
                  className="ml-2 text-gray-600 cursor-pointer"
                  onClick={() => setShowSearch(true)}
                />
              )
              }
            </li>
          </ul>
        </div>


        {mobileMenu && (
          <ul className="lg:hidden px-6 pb-4 flex flex-col gap-2 text-base font-medium navbar-links active">
            {navItems.map((item, index) => (
              <li key={index} className="nav-item relative">
                <button
                  onClick={() => toggleDropdown(index)}
                  className="w-full text-left py-2 border-b"
                >
                  {item.label} ▾
                </button>

                {item.dropdown && openDropdown === index && (
                  <div className="flex flex-col bg-gray-50 border rounded-md mt-1">
                    {item.dropdown.map((sub, subIndex) => (
                      <Link
                        key={subIndex}
                        to={sub.path}
                        onClick={handleLinkClick}
                        className="px-4 py-2 hover:bg-gray-100 text-sm border-b last:border-b-0"
                      >
                        {sub.name}
                      </Link>
                    ))}
                  </div>
                )}
              </li>
            ))}

            <li className="nav-item">
              <Link
                to="/contact"
                onClick={handleLinkClick}
                className="mt-2 bg-black text-white px-5 py-2 rounded-md text-center"
              >
                Contact Us
              </Link>
            </li>

            <li className="mt-2">
              {showSearch ? (
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={handleSearch}
                  placeholder="Search..."
                  className="w-full px-4 py-2 border border-gray-300 rounded-full text-sm focus:outline-none"
                  autoFocus
                />
              ) : (
                <FaSearch
                  className="text-gray-600 cursor-pointer"
                  onClick={() => setShowSearch(true)}
                />
              )}
            </li>
          </ul>
        )}
      </div>
      <div>
        <ScrollingNotice />
      </div>
    </>
  );
}
